<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col"><Topbar ref="con1" @inid="inid" /></div>
    </div>
    <div class="row">
      <div class="col"><Bottombar ref="con2" /></div>
    </div>
  </div>        
</template>
<script>
import { mapState } from "vuex";
import Topbar from "../controact/uscontrol/Verify_topbar"
import Bottombar from "../controact/uscontrol/Verify_bottomtbar.vue"


export default {
  name: 'Line_report',   
  components: {
    Topbar,
    Bottombar,
  },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
  },
  mounted() {

  },
  methods: {
    inid(){
      this.$refs["con2"].inid()
    }
  },
};
</script>